const kidsIntensiveFrontRulesKeys = {
    'KIDS-INTENSIVE-LIST-ITEM-REMOVE': 'kids-intensive-list-item-remove',
    'KIDS-INTENSIVE-ITEM-ARRIVALS-LIST-ROW-REMOVE': 'kids-intensive-item-arrivals-list-row-remove',
}

const kidsIntensiveFrontRulesArray = [
    { key: kidsIntensiveFrontRulesKeys['KIDS-INTENSIVE-LIST-ITEM-REMOVE'], label: 'frontRoles.sidebar.kids.intensive.removeItem' },
    { key: kidsIntensiveFrontRulesKeys['KIDS-INTENSIVE-ITEM-ARRIVALS-LIST-ROW-REMOVE'], label: 'frontRoles.sidebar.kids.intensive.removeRow' },
]

module.exports = {
    kidsIntensiveFrontRulesKeys,
    kidsIntensiveFrontRulesArray
}